import { Message } from 'element-ui'

import i18n from './i18'
import TreeScrollNotInBody from '@/components/scrollnotinbody/index.vue'

import { dateFilter, ellipsisFilter } from './filter'

export default {
  install(Vue) {
    Vue.prototype.$addSuccess = addSuccess
    Vue.prototype.$delSuccess = delSuccess
    Vue.prototype.$editSuccess = editSuccess
    Vue.component('TreeScrollNotInBody', TreeScrollNotInBody)
    Vue.filter('dateFilter', dateFilter)
    Vue.filter('ellipsisFilter', ellipsisFilter)
  }
}

function addSuccess(message) {
  Message({
    message: message || i18n.t('operation.addSuccess'), // this.$t('operation.addSuccess'),
    type: 'success',
    duration: 5 * 1000
  })
}

function delSuccess(message) {
  Message({
    message: message || i18n.t('operation.delSuccess'), // this.$t('operation.addSuccess'),
    type: 'success',
    duration: 5 * 1000
  })
}

function editSuccess(message) {
  Message({
    message: message || i18n.t('operation.editSuccess'), // this.$t('operation.addSuccess'),
    type: 'success',
    duration: 5 * 1000
  })
}



// WEBPACK FOOTER //
// ./src/lib/init.js